















































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseVue from "@/core/BaseVue";
import Direccion from "@/models/direccion.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import MapComponent from "@/components/map/map.vue";

@Component({
  components: { MapComponent }
})
export default class DireccionComponent extends BaseVue {
  @Prop() public value!: Direccion;
  @Prop() public direccionId!: number;
  @Prop() public hideMap!: boolean;
  @Prop() public hideNo!: boolean;
  @Prop() public hideRef!: boolean;
  @Prop() public hideCom!: boolean;
  @Prop() public height!: boolean;

  model = new Direccion();
  location: any = String();

  region: any = {};
  provincia: any = {};
  municipio: any = {};
  distritoMunicipal: any = {};
  seccion: any = {};
  barrio: any = {};

  get mapHeight() {
    return `height:${this.height || 500}px`;
  }

  selectRegion(value: any, added: boolean = true) {
    if (added) {
      this.model.codRegion = value.codigo;
      this.region = value;
    } else {
      this.model.codRegion = undefined;
      this.region = {};
    }

    this.$emit("region", value);
  }
  selectProvincia(value: any, added: boolean = true) {
    if (added) {
      this.model.codProvincia = value.codigo;
      this.provincia = value;
    } else {
      this.model.codProvincia = undefined;
      this.provincia = {};
    }

    this.$emit("provincia", value);
  }
  selectMunicipio(value: any, added: boolean = true) {
    if (added) {
      this.model.codMunicipio = value.codigo;
      this.municipio = value;
    } else {
      this.model.codMunicipio = undefined;
      this.municipio = {};
    }

    this.$emit("municipio", value);
  }

  selectDistritoMunicipal(value: any, added: boolean = true) {
    if (added) {
      this.model.codDistritoMunicipal = value.codigo;
      this.distritoMunicipal = value;
    } else {
      this.model.codDistritoMunicipal = undefined;
      this.distritoMunicipal = {};
    }

    this.$emit("distritoMunicipal", value);
  }
  selectSeccion(value: any, added: boolean = true) {
    if (added) {
      this.model.codSeccion = value.codigo;
      this.seccion = value;
    } else {
      this.model.codSeccion = undefined;
      this.seccion = {};
    }

    this.$emit("seccion", value);
  }

  selectBarrio(value: any, added: boolean = true) {
    if (added) {
      this.model.codBarrio = value.codigo;
      this.barrio = value;
    } else {
      this.model.codBarrio = undefined;
      this.barrio = {};
    }

    this.$emit("barrio", value);
  }
  get query() {
    var pais = "Republica dominicana";
    if (this.model.calleStr)
      return `${pais}, ${this.provincia.nombre} ${this.barrio.nombre} calle ${this.model.calleStr}`;

    if (this.barrio.nombre)
      return `${pais}, ${this.provincia.nombre} ${this.barrio.nombre}`;

    if (this.provincia.nombre) return `${pais}, ${this.provincia.nombre}`;

    return `${pais}`;
  }

  @Watch("model", { deep: true })
  onChangeModel(value: Direccion) {
    var data = value;
    if (this.location) {
      data.latitude = this.location.lat();
      data.longitude = this.location.lng();
    }

    this.$emit("input", value);
  }
@Watch("value", { deep: true, immediate:true })
  onValueModel(value: Direccion) {
    this.model = value;
  }
  public async isValid() {
    try {
      let isValid = await this.$validator.validateAll();
      if (isValid) return true;

      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
      return false;
    }
  }
}
